import { createSiteApp } from './create-app';
import createSiteRouter from './router';

const data = document.getElementById('gallery-seed');
const seed = data ? JSON.parse(data.textContent) : {};
const router = createSiteRouter();
const app = createSiteApp(router, seed);

// Keep the rendered HTML visible until the initial route is ready.
router.isReady().then(() => app.mount('#app'));
